import BaseFilter from "./base_filter"
import { createElement, createFormGroup, createSummary } from "./dom"

export default class GenericSpanFilter extends BaseFilter {
  createForm() {
    super.createForm()

    this.fromInput = createElement("input", { className: "form-control" })
    this.toInput = createElement("input", { className: "form-control" })
    this.fromInput.type = "text"
    this.toInput.type = "text"

    this.element.append(
      createElement("label", { text: this.definition.title }),
      document.createElement("br"),
      createFormGroup(this.definition.labels.from, this.fromInput),
      createFormGroup(this.definition.labels.to, this.toInput),
    )
    this.appendApplyButton()

    return this.element
  }

  read() { return this.result([this.fromInput.value || "0", this.toInput.value || "0"]) }

  summary(value) { return createSummary(this.definition.title, `${value[0]} - ${value[1]}`) }
}
